import {
  SUBMIT_TAT_ANALYSIS_REQUEST,
  SUBMIT_TAT_ANALYSIS_SUCCESS,
  SUBMIT_TAT_ANALYSIS_FAIL,
  SUBMIT_TAT_ANALYSIS_RESET,
  GET_MY_TAT_ANALYSIS_REQUEST,
  GET_MY_TAT_ANALYSIS_SUCCESS,
  GET_MY_TAT_ANALYSIS_FAIL,
  GET_MY_TAT_ANALYSIS_RESET,
  GET_TAT_STATISTICS_REQUEST,
  GET_TAT_STATISTICS_SUCCESS,
  GET_TAT_STATISTICS_FAIL,
  GET_TAT_STATISTICS_RESET,
  UPDATE_TAT_ANALYSIS_REQUEST,
  UPDATE_TAT_ANALYSIS_SUCCESS,
  UPDATE_TAT_ANALYSIS_FAIL,
  UPDATE_TAT_ANALYSIS_RESET,
  DELETE_TAT_ANALYSIS_REQUEST,
  DELETE_TAT_ANALYSIS_SUCCESS,
  DELETE_TAT_ANALYSIS_FAIL,
  DELETE_TAT_ANALYSIS_RESET,
  GET_TAT_ANALYSIS_REPORT_REQUEST,
  GET_TAT_ANALYSIS_REPORT_SUCCESS,
  GET_TAT_ANALYSIS_REPORT_FAIL,
  GET_TAT_ANALYSIS_REPORT_RESET,
} from '../constants/tatAnalysisConstant'

export const submitTatAnalysisReducer = (state = {}, action) => {
  switch (action.type) {
    case SUBMIT_TAT_ANALYSIS_REQUEST:
      return { loadingSubmitTatAnalysis: true }
    case SUBMIT_TAT_ANALYSIS_SUCCESS:
      return {
        loadingSubmitTatAnalysis: false,
        submitTatAnalysisData: action.payload,
      }
    case SUBMIT_TAT_ANALYSIS_FAIL:
      return {
        loadingSubmitTatAnalysis: false,
        errorSubmitTatAnalysis: action.payload,
      }
    case SUBMIT_TAT_ANALYSIS_RESET:
      return {}
    default:
      return state
  }
}

export const getMyTatAnalysisReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_MY_TAT_ANALYSIS_REQUEST:
      return { loadingMyTatAnalysis: true }
    case GET_MY_TAT_ANALYSIS_SUCCESS:
      return {
        loadingMyTatAnalysis: false,
        myTatAnalysisData: action.payload,
      }
    case GET_MY_TAT_ANALYSIS_FAIL:
      return {
        loadingMyTatAnalysis: false,
        errorMyTatAnalysis: action.payload,
      }
    case GET_MY_TAT_ANALYSIS_RESET:
      return {}
    default:
      return state
  }
}

export const getTatStatisticsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_TAT_STATISTICS_REQUEST:
      return { loadingTatStatistics: true }
    case GET_TAT_STATISTICS_SUCCESS:
      return {
        loadingTatStatistics: false,
        tatStatisticsData: action.payload,
      }
    case GET_TAT_STATISTICS_FAIL:
      return {
        loadingTatStatistics: false,
        errorTatStatistics: action.payload,
      }
    case GET_TAT_STATISTICS_RESET:
      return {}
    default:
      return state
  }
}

export const updateTatAnalysisReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_TAT_ANALYSIS_REQUEST:
      return { loadingUpdateTatAnalysis: true }
    case UPDATE_TAT_ANALYSIS_SUCCESS:
      return {
        loadingUpdateTatAnalysis: false,
        updateTatAnalysisData: action.payload,
      }
    case UPDATE_TAT_ANALYSIS_FAIL:
      return {
        loadingUpdateTatAnalysis: false,
        errorUpdateTatAnalysis: action.payload,
      }
    case UPDATE_TAT_ANALYSIS_RESET:
      return {}
    default:
      return state
  }
}

export const deleteTatAnalysisReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_TAT_ANALYSIS_REQUEST:
      return { loadingDeleteTatAnalysis: true }
    case DELETE_TAT_ANALYSIS_SUCCESS:
      return {
        loadingDeleteTatAnalysis: false,
        deleteTatAnalysisData: action.payload,
      }
    case DELETE_TAT_ANALYSIS_FAIL:
      return {
        loadingDeleteTatAnalysis: false,
        errorDeleteTatAnalysis: action.payload,
      }
    case DELETE_TAT_ANALYSIS_RESET:
      return {}
    default:
      return state
  }
}


export const getTatAnalysisReportReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_TAT_ANALYSIS_REPORT_REQUEST:
      return { loadingTatAnalysisReport: true };
    case GET_TAT_ANALYSIS_REPORT_SUCCESS:
      return {
        loadingTatAnalysisReport: false,
        tatAnalysisReportData: action.payload,
      };
    case GET_TAT_ANALYSIS_REPORT_FAIL:
      return {
        loadingTatAnalysisReport: false,
        errorTatAnalysisReport: action.payload,
      };
    case GET_TAT_ANALYSIS_REPORT_RESET:
      return {};
    default:
      return state;
  }
};
